import { EventTrackingProvider as EventTrackingClientProvider } from '@DigitalZoneApp/event-tracking/front';

export function EventTrackingProvider({ children }: { children: React.ReactNode }) {
  return (
    <EventTrackingClientProvider
      config={{
        provider: (import.meta.env.VITE_APP_EVENT_PROVIDER as 'rudderstack') ?? 'rudderstack',
        writeKey: import.meta.env.VITE_PUBLIC_RS_WRITE_KEY,
        dataPlaneUrl: import.meta.env.VITE_PUBLIC_RS_DATAPLANE,
        consent: () => true, // safe here — defined on the client
        defaultContext: () => ({ app: 'web', env: import.meta.env.VITE_APP_ENV }),
        loadOptions: { sessions: { autoTrack: true } },
      }}
    >
      {children}
    </EventTrackingClientProvider>
  );
}
